import { render, staticRenderFns } from "./Users-reports.vue?vue&type=template&id=5095ea36&"
import script from "./Users-reports.vue?vue&type=script&lang=js&"
export * from "./Users-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports